import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import type { PublicConfig } from './api';

/**
 * Cognito Hosted UI with Authorization Code + PKCE (public client, no secret).
 * IMPLEMENTED BUT NOT VERIFIED: no Cognito user pool exists yet (Gate 3).
 */
export function createCognitoManager(cfg: NonNullable<PublicConfig['cognito']>) {
  return new UserManager({
    authority: cfg.issuer,
    client_id: cfg.clientId,
    redirect_uri: `${window.location.origin}/auth/callback`,
    post_logout_redirect_uri: window.location.origin,
    response_type: 'code',
    scope: 'openid email',
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  });
}

/** Seeded synthetic users offered on the local dev login screen. */
export const DEV_USERS = [
  ['priya.raman@northstar.example', 'Northstar · admin'],
  ['tom.okafor@northstar.example', 'Northstar · member'],
  ['elena.varga@ledgerline-audit.example', 'Northstar · auditor'],
  ['hannah.cole@meridian.example', 'Meridian · admin'],
  ['sam.whitfield@meridian.example', 'Meridian · member'],
  ['marcus.lee@apex.example', 'Apex · admin'],
  ['wei.zhang@apex.example', 'Apex · auditor'],
  ['ravi.menon@brightwater-consulting.example', 'Meridian member + Apex auditor'],
] as const;
